const MenuData = [
  {
    title: "메뉴",
    sectionTitle: true,
  },
  {
    title: "일반메뉴",
    icon: "/static/sidemenu/document.png",
    selectedIcon: "/static/sidemenu/document-selected.png",
    path: "/naver/kmong",
  },
  {
    title: "벤처인증",
    icon: "/static/sidemenu/document.png",
    selectedIcon: "/static/sidemenu/document-selected.png",
    path: "/naver/insurance/survey",
  },
  {
    title: "채팅",
    icon: "/static/sidemenu/chat.png",
    selectedIcon: "/static/sidemenu/chat-selected.png",
    path: "/naver/insurance/chat",
  },
  {
    title: "대시보드",
    icon: "/static/sidemenu/dashboard.png",
    selectedIcon: "/static/sidemenu/dashboard-selected.png",
    path: "/naver/insurance/dashboard",
  },
  {
    title: "수기 거래 관리",
    icon: "/static/sidemenu/pen.png",
    selectedIcon: "/static/sidemenu/pen-selected.png",
    path: "/naver/insurance/table",
  },
  {
    title: "엑셀 표 수정",
    icon: "/static/sidemenu/document.png",
    selectedIcon: "/static/sidemenu/document-selected.png",
    path: "/naver/insurance/table-editor",
  },
  {
    title: "견적 요청",
    icon: "/static/sidemenu/calculator.png",
    selectedIcon: "/static/sidemenu/calculator-selected.png",
    path: "/naver/insurance/quotation",
  },
  {
    title: "질문답변",
    icon: "/static/sidemenu/qa.png",
    selectedIcon: "/static/sidemenu/qa-selected.png",
    path: "/naver/insurance/qna",
  },
  {
    title: "자기소개서",
    icon: "/static/sidemenu/file.png",
    selectedIcon: "/static/sidemenu/file-selected.png",
    path: "/naver/insurance/self-introduction",
  },
  {
    title: "예상세금 서비스",
    icon: "/static/sidemenu/estimate.png",
    selectedIcon: "/static/sidemenu/estimate-selected.png",
    path: "/naver/insurance/tax-info",
  },
  {
    title: "경정청구",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/naver/insurance/tax-reassessment",
  },
  {
    title: "메인배너 수정",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/naver/insurance/banner-editor",
  },
  {
    title: "사용자 관리",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/naver/insurance/user-management",
  },
  {
    title: "영업 현황",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/naver/insurance/progress",
  },
  {
    title: "서버 관리",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/naver/insurance/server-management",
  },
  {
    title: "클래스 메뉴 관리",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/naver/insurance/menu-editor",
  },
  {
    title: "커뮤 메뉴 관리",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/naver/insurance/menu-editor",
  },

  {
    title: "divider",
  },
  {
    title: "손익",
    sectionTitle: true,
  },
  {
    title: "매출",
    icon: "/static/sidemenu/graph.png",
    selectedIcon: "/static/sidemenu/graph-selected.png",
    path: "/sales",
  },
  {
    title: "매입",
    icon: "/static/sidemenu/cart.png",
    selectedIcon: "/static/sidemenu/cart-selected.png",
    path: "/purchases",
  },
  {
    title: "수기 거래 관리",
    icon: "/static/sidemenu/pen.png",
    selectedIcon: "/static/sidemenu/pen-selected.png",
    path: "/manual-transactions",
  },
  {
    title: "원천징수",
    icon: "/static/sidemenu/paper.png",
    selectedIcon: "/static/sidemenu/paper-selected.png",
    path: "/withholding-tax",
  },
  {
    title: "예상 손익",
    icon: "/static/sidemenu/chart.png",
    selectedIcon: "/static/sidemenu/chart-selected.png",
    path: "/expected-profit",
  },
  {
    title: "divider",
  },
  {
    title: "자금",
    sectionTitle: true,
  },
  {
    title: "계좌잔액",
    icon: "/static/sidemenu/wallet.png",
    selectedIcon: "/static/sidemenu/wallet-selected.png",
    path: "/account-balance",
  },
  {
    title: "divider",
  },
  {
    title: "세금",
    sectionTitle: true,
  },
  {
    title: "납부한 세금",
    icon: "/static/sidemenu/receipt.png",
    selectedIcon: "/static/sidemenu/receipt-selected.png",
    path: "/paid-taxes",
  },
  {
    title: "신고 내역",
    icon: "/static/sidemenu/file.png",
    selectedIcon: "/static/sidemenu/file-selected.png",
    path: "/tax-reports",
  },
  {
    title: "고지 · 체납 · 출금 내역",
    icon: "/static/sidemenu/notice.png",
    selectedIcon: "/static/sidemenu/notice-selected.png",
    path: "/payment-history",
  },
  {
    title: "divider",
  },
  {
    title: "카드매출 분석",
    sectionTitle: true,
  },
  {
    title: "카드매출 입금예정",
    icon: "/static/sidemenu/calendar.png",
    selectedIcon: "/static/sidemenu/calendar-selected.png",
    path: "/expected-card-deposits",
  },
  {
    title: "어제 카드매출",
    icon: "/static/sidemenu/graph.png",
    selectedIcon: "/static/sidemenu/graph-selected.png",
    path: "/yesterday-card-sales",
  },
  {
    title: "divider",
  },
  {
    title: "카드지출 상세",
    sectionTitle: true,
  },
  {
    title: "카드지출",
    icon: "/static/sidemenu/card.png",
    selectedIcon: "/static/sidemenu/card-selected.png",
    path: "/card-expenses",
  },
  {
    title: "divider",
  },
  {
    title: "세무지원",
    sectionTitle: true,
  },
  {
    title: "부가가치세",
    icon: "/static/sidemenu/vat.png",
    selectedIcon: "/static/sidemenu/vat-selected.png",
    path: "/vat",
  },
  {
    title: "법인세",
    icon: "/static/sidemenu/corporate.png",
    selectedIcon: "/static/sidemenu/corporate-selected.png",
    path: "/corporate-tax",
  },
  {
    title: "종합소득세",
    icon: "/static/sidemenu/income.png",
    selectedIcon: "/static/sidemenu/income-selected.png",
    path: "/income-tax",
  },
  {
    title: "추정손익",
    icon: "/static/sidemenu/estimate.png",
    selectedIcon: "/static/sidemenu/estimate-selected.png",
    path: "/estimated-profit",
  },
  {
    title: "신고서 제출 현황",
    icon: "/static/sidemenu/document.png",
    selectedIcon: "/static/sidemenu/document-selected.png",
    path: "/report-status",
  },
  {
    title: "divider",
  },
  {
    title: "부가서비스",
    sectionTitle: true,
  },
  {
    title: "주주명부",
    icon: "/static/sidemenu/users.png",
    selectedIcon: "/static/sidemenu/users-selected.png",
    path: "/shareholders",
  },
  {
    title: "비상장주식 가치평가",
    icon: "/static/sidemenu/chart.png",
    selectedIcon: "/static/sidemenu/chart-selected.png",
    path: "/stock-valuation",
  },
  {
    title: "간편 계산기",
    icon: "/static/sidemenu/calculator.png",
    selectedIcon: "/static/sidemenu/calculator-selected.png",
    path: "/simple-calculator",
  },
];

export { MenuData };
